import { useQuery } from "@tanstack/react-query";
import { QueryKey } from "./constants";
import api, { baseUrl } from "../services/api";

export const useCities = () => {
  const queryKey = [QueryKey.Cities];

  const queryFn = async () => {
    const URL = `${baseUrl}/cities`;

    const { data } = await api.get(URL);

    return data;
  };

  return useQuery({
    queryKey: queryKey,
    queryFn: queryFn,
  });
};
